import * as React from "react"
const SvgLongArrowLeft = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.846 13.14H19a.97.97 0 0 0 .712-.288.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288H7.846l2.85-2.848a.92.92 0 0 0 .289-.7 1.02 1.02 0 0 0-1-1.012.93.93 0 0 0-.714.288L4.695 11.44q-.15.15-.213.325a1.1 1.1 0 0 0-.062.375q0 .2.062.375a.9.9 0 0 0 .213.324l4.576 4.573q.3.3.713.287a1.02 1.02 0 0 0 1-1.012.92.92 0 0 0-.287-.7z" />
  </svg>
)
export default SvgLongArrowLeft
